









































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {ResponsavelVisualizador} from '@/model/resource/ResponsavelVisualizador'
import {InputResponsavelVisualizadorSchema} from '@/schema/resource/ResponsavelVisualizador/InputResponsavelVisualizadorSchema'

@Component
export default class PersistResponsavelVisualizadorView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputResponsavelVisualizadorSchema()
  responsavelVisualizador = new ResponsavelVisualizador()

  async created() {
    this.populateResource()
    await this.populate()
  }

  populateResource() {
    this.schema.collectionResponsavel.listResponsavel()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.responsavelVisualizador.getResponsavelVisualizador(id)
    }

    $.await.done('getResponsavelVisualizador')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.responsavelVisualizador.persistResponsavelVisualizador()
    await Helper.successAndPush(
      'system.success.persist',
      '/responsavel-visualizador/list'
    )
  }
}
